import { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Center, Loader } from '@mantine/core'
import { AppButton, AppCard, AppStack, AppText } from '../../app/common/ui'
import agent from '../../app/api/agent'
import { useStore } from '../../app/stores/store'

export default function ConfirmAccountDeletionPage () {
  const location = useLocation()
  const history = useHistory()
  const { userStore } = useStore()
  const [loading, setLoading] = useState(true)
  const [success, setSuccess] = useState<boolean | null>(null)

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const userId = params.get('userId')
    const token = params.get('token')
    if (!userId || !token) {
      setSuccess(false)
      setLoading(false)
      return
    }
    agent.Account.confirmDeletion(userId, token)
      .then(() => {
        setSuccess(true)
        userStore.logout()
      })
      .catch(() => setSuccess(false))
      .finally(() => setLoading(false))
  }, [location.search, userStore])

  if (loading) {
    return (
      <Center style={{ minHeight: 280 }}>
        <Loader size="lg" />
      </Center>
    )
  }

  if (success) {
    return (
      <AppCard shadow="sm" padding="lg" sx={{ maxWidth: 480, margin: '2rem auto' }}>
        <AppStack spacing="md">
          <AppText weight={600} color="green" size="lg">
            Account deletion confirmed
          </AppText>
          <AppText size="sm" color="dimmed">
            Your account is deactivated. Personal data removal continues; some records may be purged after a 30-day grace period.
          </AppText>
          <AppButton onClick={() => history.push('/')}>Return home</AppButton>
        </AppStack>
      </AppCard>
    )
  }

  return (
    <AppCard shadow="sm" padding="lg" sx={{ maxWidth: 480, margin: '2rem auto', borderColor: '#fa5252' }}>
      <AppStack spacing="md">
        <AppText weight={600} color="red" size="lg">
          Invalid or expired link
        </AppText>
        <AppText size="sm" color="dimmed">
          Request a new deletion link from Settings or contact privacy@gunslop.com.
        </AppText>
        <AppButton variant="light" onClick={() => history.push('/settings')}>
          Go to Settings
        </AppButton>
      </AppStack>
    </AppCard>
  )
}
